import React, { memo, useRef, useEffect } from 'react';

import useCsvData from '~/kits/general/scripts/hooks/useCsvData';
import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();

export default memo((props) => {
  const data = useCsvData('umfragen_spd.csv', props.parseRow);
  const canvasNode = useRef(null);

  useEffect(() => {
    if (canvasNode.current && data) {
      const ctx = canvasNode.current.getContext('2d');
      const size = isSmallScreen ? 1.2 : 1.5;

      ctx.globalAlpha = 0.2;

      data.forEach(d => {
        ctx.beginPath();
        ctx.arc(props.xScale(d.date), props.yScale(d.value) - 20, size, 0, 2 * Math.PI);
        ctx.fillStyle = 'rgba(163,163,163,0.5)';
        ctx.strokeStyle = '#A3A3A3';

        ctx.stroke();
        ctx.fill();
      });
    }
  }, [data]);

  return (
    <canvas
      className="chart__canvas"
      ref={canvasNode}
      width={props.width}
      height={props.height}
      style={props.style}
    />
  );
});
